import { FC, useEffect, useState } from 'react';
import { TbCornerDownLeft, TbSwitchVertical } from 'react-icons/tb';

import { AppIcon } from '@/assets';
import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { MiddleDot, SmallTag } from '@/shared';

// interface FooterProps {}

const Footer: FC = ({}): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    const { token } = useAntDesignTheme();

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '12px 16px',
                borderTop: `1px solid ${token.colorBorder}`,
                fontSize: '12px',
                color: token.colorText,
                background: token.colorBgBase,
            }}
        >
            <span>
                <span
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        window.open('https://countercyclical.com', '_blank');
                    }}
                >
                    <img
                        src={AppIcon}
                        height='16'
                        width='16'
                        alt='Countercyclical - App Icon'
                        style={{ verticalAlign: '-0.2rem' }}
                    />
                    <span style={{ fontWeight: 500, marginLeft: '0.5rem', color: token.colorTextTertiary }}>
                        Countercyclical
                    </span>
                </span>
                <span style={{ color: token.colorTextTertiary }}>
                    <MiddleDot horizontalMargin={'0.375rem'} />
                    <TbSwitchVertical style={{ verticalAlign: '-0.1rem' }} /> to navigate
                    <MiddleDot horizontalMargin={'0.375rem'} />
                    <TbCornerDownLeft style={{ verticalAlign: '-0.1rem' }} /> to select
                </span>
            </span>
            <div>
                <SmallTag message={'esc'} styles={{ marginRight: '0.25rem' }} />
                to Close
            </div>
        </div>
    );
};

export default Footer;
